import React, { Component } from "react";
import {
  company,
  loading,
  NavbarAdmin,
  Pagination,
  Modal,
  Select,
  DatePicker,
  DateRangeFields,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  format_date,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission.js";
import { formatNumber } from "../../utils/formatting";

const PAGE_SIZE = 10;

// วันหยุดบริษัท (ISS - ปฏิทินงานช่าง) - ธงวันหยุดทั้งวัน ใช้ร่วมกับทุกแถวบนปฏิทินฝั่งหน้า scheduling.js และฝั่งแอปมือถือ
// backend (company-holiday.route.js) ไม่รองรับกรองช่วงวันที่ฝั่ง server จึงดึงมาทั้งหมด (page: 0) แล้วกรอง/แบ่งหน้าเองที่นี่
export default class CompanyHolidays extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_is_active: "",
      filter_start_date: "",
      filter_end_date: "",

      page: 1,
      all_data: [],
      count: 0,
      data: [],

      modal_create: false,
      modal_update: false,

      // Form states
      uid: "",
      company_id: company?.id,
      name: "",
      reason: "",
      start_date: "",
      end_date: "",
      is_active: "Active",
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get();
  }

  // กรองช่วงวันที่ฝั่ง client (overlap กับช่วงที่เลือก) เพราะ backend ไม่รองรับ start_date/end_date เป็น query param
  applyDateRangeFilter = (rows, filterStartDate, filterEndDate) => {
    if (!filterStartDate && !filterEndDate) return rows;
    return rows.filter((item) => {
      if (filterStartDate && item.end_date < filterStartDate) return false;
      if (filterEndDate && item.start_date > filterEndDate) return false;
      return true;
    });
  };

  Get = async (page = 1) => {
    const { filter_search, filter_is_active, filter_start_date, filter_end_date } = this.state;
    loading(true);

    const result = await GET("admin/company-holidays", {
      page: 0,
      data_search: filter_search || "",
      is_active: filter_is_active || "",
    });

    if (result?.status) {
      const all_data = this.applyDateRangeFilter(result.data || [], filter_start_date, filter_end_date);
      const start = (page - 1) * PAGE_SIZE;
      this.setState({
        all_data,
        data: all_data.slice(start, start + PAGE_SIZE),
        count: all_data.length,
        page,
      });
    }

    loading(false);
  };

  changePage = (page) => {
    const start = (page - 1) * PAGE_SIZE;
    this.setState({ page, data: this.state.all_data.slice(start, start + PAGE_SIZE) });
  };

  openCreate = () =>
    this.setState({
      modal_create: true,
      modal_update: false,
      uid: "",
      name: "",
      reason: "",
      start_date: "",
      end_date: "",
      is_active: "Active",
    });

  openEdit = (item) =>
    this.setState({
      modal_create: false,
      modal_update: true,
      uid: item.uid,
      name: item.name || "",
      reason: item.reason || "",
      start_date: item.start_date || "",
      end_date: item.end_date || "",
      is_active: item.is_active ? "Active" : "Inactive",
    });

  handleSave = async () => {
    const { uid, company_id, name, reason, start_date, end_date, is_active } = this.state;

    if (!name.trim()) {
      await alert("", "warning", t("warning"), t("ch_validate_name"));
      return;
    }
    if (!start_date) {
      await alert("", "warning", t("warning"), t("ch_validate_start_date"));
      return;
    }
    if (!end_date) {
      await alert("", "warning", t("warning"), t("ch_validate_end_date"));
      return;
    }
    if (end_date < start_date) {
      await alert("", "warning", t("warning"), t("ch_validate_date_range"));
      return;
    }

    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);

      const body = {
        company_id,
        name: name.trim(),
        reason: reason.trim(),
        start_date,
        end_date,
        is_active: is_active === "Active",
      };

      const result = !uid
        ? await POST("admin/company-holidays", body)
        : await PUT("admin/company-holidays/" + uid, body);

      if (result?.status === true) {
        alert("#", "success", t("success"), t("save_success"));
        this.setState({ modal_create: false, modal_update: false });
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  handleDelete = async (uid) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      const result = await DELETE("admin/company-holidays/" + uid, null);
      if (result?.status) {
        alert("#", "success", t("success"), t("delete_success"));
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  render() {
    const {
      data, count, page,
      filter_search, filter_is_active, filter_start_date, filter_end_date,
      modal_create, modal_update,
      name, reason, start_date, end_date, is_active,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                {/* Header */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("ch_title")}</h3>
                        <div className="text-secondary text-14">{t("ch_desc")}</div>
                    </div>
                </div>

                {/* Filter Toolbar */}
                <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
                    <div className="d-flex flex-wrap align-items-end justify-content-between gap-3">
                        <div className="d-flex flex-wrap gap-2 flex-grow-1 align-items-end">
                            <div>
                                <input
                                    type="text"
                                    className="form-control wpx-280"
                                    style={{ height: "38px" }}
                                    placeholder={t("ch_search_placeholder")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                                />
                            </div>
                            <DateRangeFields
                                type="th"
                                className="form-control"
                                fieldStyle={{ width: 160 }}
                                startPlaceholder={t("start_date")}
                                endPlaceholder={t("end_date")}
                                startValue={filter_start_date}
                                endValue={filter_end_date}
                                onChange={({ start, end }) => this.setState({ filter_start_date: start, filter_end_date: end })}
                            />
                            <Select
                                className="form-control wpx-180"
                                options={[
                                    { value: "true", label: t("active") },
                                    { value: "false", label: t("inactive") },
                                ]}
                                value={filter_is_active}
                                onChange={(e) => this.setState({ filter_is_active: e || "" })}
                                placeholder={t("all_status")}
                            />
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() =>
                                        this.setState(
                                            { filter_search: "", filter_is_active: "", filter_start_date: "", filter_end_date: "" },
                                            () => this.Get(1)
                                        )
                                    }
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        {can("company-holiday.create") ? (
                            <button className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center" onClick={this.openCreate}>
                                <span className="me-2 text-16">+</span> {t("ch_add_btn")}
                            </button>
                        ) : null}
                    </div>
                </div>

                {/* Table */}
                <div className="bg-white rounded-4 shadow-sm overflow-hidden">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "900px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 px-3 border-0">{t("ch_col_name")}</th>
                                    <th className="py-3 px-3 border-0">{t("ch_col_date_range")}</th>
                                    <th className="py-3 px-3 border-0">{t("ch_col_reason")}</th>
                                    <th className="py-3 px-3 border-0 text-center wpx-120">{t("status")}</th>
                                    <th className="py-3 px-3 border-0 text-center wpx-120">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length === 0 ? (
                                    <tr>
                                        <td colSpan={5} className="text-center text-secondary py-5">
                                            <div className="d-flex flex-column align-items-center gap-2">
                                                <span>{t("no_data")}</span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    data.map((item, idx) => (
                                        <tr key={item.uid || idx} className="border-bottom border-light bg-white">
                                            <td className="px-3">
                                                <div className="text-dark text-14 fw-semibold">{item.name || "-"}</div>
                                            </td>
                                            <td className="px-3">
                                                <div className="text-dark text-14">
                                                    {format_date(item.start_date, "dd/mm/yyyy", "th")} - {format_date(item.end_date, "dd/mm/yyyy", "th")}
                                                </div>
                                            </td>
                                            <td className="px-3">
                                                <div className="text-secondary text-14 text-truncate" style={{ maxWidth: 260 }}>
                                                    {item.reason || "-"}
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                {item.is_active ? (
                                                    <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                                ) : (
                                                    <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                                )}
                                            </td>
                                            <td className="text-center">
                                                <div className="d-flex align-items-center gap-2 justify-content-center">
                                                    <ActionIconButton label={can("company-holiday.update") ? t("edit") : t("view")} icon={can("company-holiday.update") ? ACTION_ICONS.edit : ACTION_ICONS.view} variant={can("company-holiday.update") ? "warning" : "primary"} onClick={() => this.openEdit(item)} />
                                                    {can("company-holiday.delete") ? <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.handleDelete(item.uid)} /> : null}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12 gap-2">
                    <div>
                        {t("showing")} {count === 0 ? 0 : formatNumber((page - 1) * PAGE_SIZE + 1)}-{formatNumber((page - 1) * PAGE_SIZE + data.length)} {t("of")} {formatNumber(count)} {t("ch_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / PAGE_SIZE) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, p) => this.changePage(p)} />
                </div>
            </div>

            {/* MODAL: CREATE / EDIT */}
            <Modal show={modal_create || modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("ch_modal_edit") : t("ch_modal_create")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
<fieldset disabled={this.state.modal_update && !can("company-holiday.update")} className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
                    <div className="row g-3">
                        <div className="col-12">
                            <label className="form-label text-14 text-dark mb-2">
                                {t("ch_field_name")} <span className="text-danger">*</span>
                            </label>
                            <input type="text" className="form-control py-2" value={name} onChange={(e) => this.setState({ name: e.target.value })} />
                        </div>

                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark mb-2">
                                {t("start_date")} <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                                type="th"
                                className="form-control py-2 text-dark"
                                value={start_date}
                                onChange={(val) => this.setState({ start_date: val || "", end_date: end_date && end_date < val ? val : end_date })}
                                placeholder={t("date_placeholder")}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark mb-2">
                                {t("end_date")} <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                                type="th"
                                className="form-control py-2 text-dark"
                                value={end_date}
                                onChange={(val) => this.setState({ end_date: val || "" })}
                                placeholder={t("date_placeholder")}
                                min={start_date || undefined}
                            />
                        </div>

                        <div className="col-12">
                            <label className="form-label text-14 text-dark mb-2">{t("reason")}</label>
                            <textarea className="form-control py-2" rows={3} value={reason} onChange={(e) => this.setState({ reason: e.target.value })} />
                        </div>

                        {/* Status */}
                        <div className="col-12 mt-2 border-top pt-3">
                            <h6 className="fw-bold mb-3 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf772"}</span> {t("status")}
                            </h6>
                            <div className="d-flex gap-4">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="chStatus"
                                        id="chActive"
                                        checked={is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="chActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="chStatus"
                                        id="chInactive"
                                        checked={is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="chInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
</Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
                    {(!this.state.modal_update || can("company-holiday.update")) ? <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        onClick={this.handleSave}
                    >
                        <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button> : null}
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
